/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Card } from "antd";
import { getContractDetailType } from "../../../../ducks/types";
import dayjs from "dayjs";
import {
  BILLING_MODAL,
  getCompanyInitials,
  NET_TERMS,
  PRICING_MODAL,
} from "../../../../../../config/utils";
import { ArrowRightOutlined } from "@ant-design/icons";
import LabourIcon from "../../../../../../atoms/CustomIcons/LabourIcon";
import GasIcon from "../../../../../../atoms/CustomIcons/GasIcon";

interface PropsType {
  sidebarData: getContractDetailType | null;
}

export default function TabDetails(props: PropsType) {
  const { sidebarData } = props;
  return (
    <div className="dashboardTabContent">
      <Card className="right_inner" style={{ padding: "20px" }}>
        <h6> General details </h6>
        <div className="widgetCard" style={{ marginBottom: "24px" }}>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Account manager:</h6>
            <h6 className="miniDetail">
              {sidebarData?.account_manager_name ? (
                <div className="text_with_avatar">
                  {sidebarData?.account_manager_image_url ? (
                    <div className="participant_avatar">
                      <img
                        src={sidebarData?.account_manager_image_url}
                        alt=""
                      />
                    </div>
                  ) : (
                    <div className="participant_avatar">
                      <Avatar>
                        {getCompanyInitials(sidebarData?.account_manager_name)}
                      </Avatar>
                    </div>
                  )}

                  {sidebarData?.account_manager_name}
                </div>
              ) : (
                "-"
              )}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Type of sale</h6>
            <h6 className="miniDetail">Base contract</h6>
          </div>
        </div>
        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Production manager:</h6>
            <h6 className="miniDetail">
              {sidebarData?.production_managers &&
              sidebarData?.production_managers?.length > 0
                ? sidebarData?.production_managers.map((manager) => (
                    <div className="text_with_avatar" key={manager.name}>
                      <div className="participant_avatar">
                        {manager?.image ? (
                          <img src={manager?.image} alt="" />
                        ) : (
                          <Avatar>{getCompanyInitials(manager.name)}</Avatar>
                        )}
                      </div>

                      <span>{manager.name}</span>
                    </div>
                  ))
                : "-"}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Crew:</h6>
            <h6 className="miniDetail">
              {sidebarData?.crews?.map((crew) => crew).join(", ")}
            </h6>
          </div>
        </div>
      </Card>
      <Card className="right_inner" style={{ padding: "20px" }}>
        <h6> Contract terms </h6>
        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Start date </h6>
            <h6 className="miniDetail">
              {" "}
              {dayjs(sidebarData?.start_date).format("MMM D, YYYY")}{" "}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> End date </h6>
            <h6 className="miniDetail">
              {" "}
              {dayjs(sidebarData?.end_date).format("MMM D, YYYY")}{" "}
            </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Renewable </h6>
            <h6 className="miniDetail">
              {" "}
              {sidebarData?.is_renewable ? "Yes" : "No"}{" "}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Pricing model </h6>
            <h6 className="miniDetail">
              {" "}
              {sidebarData?.pricing_model
                ? PRICING_MODAL[
                    sidebarData?.pricing_model as keyof typeof PRICING_MODAL
                  ]
                : "-"}{" "}
            </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Billing </h6>
            <h6 className="miniDetail">
              {sidebarData?.billing
                ? BILLING_MODAL[
                    sidebarData?.billing as keyof typeof BILLING_MODAL
                  ]
                : "-"}{" "}
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Net terms </h6>
            <h6 className="miniDetail">
              {" "}
              {sidebarData?.net_terms
                ? NET_TERMS[sidebarData?.net_terms as keyof typeof NET_TERMS]
                : "-"}{" "}
            </h6>
          </div>
        </div>
      </Card>

      <Card className="right_inner" style={{ padding: "20px" }}>
        <h6 style={{ marginBottom: "8px" }}>
          Visit & hours monthly allocation
        </h6>
        <p style={{ marginBottom: "24px" }}>
          Distribution of visits and hours for each month as per service needs.
        </p>
        <div
          className="widgetCard"
          style={{ flexDirection: "column", gap: "8px" }}
        >
          <div className="allocation_tiles">
            <div className="content">
              <div className="icon_avatar">
                <LabourIcon />
              </div>
              <div>
                <h5 style={{ marginBottom: "4px" }}> Weekly service </h5>
                <p> Click to view</p>
              </div>
            </div>
            <div className="arrow_go">
              <ArrowRightOutlined />
            </div>
          </div>
          <div className="allocation_tiles">
            <div className="content">
              <div className="icon_avatar">
                <GasIcon />
              </div>
              <div>
                <h5 style={{ marginBottom: "4px" }}> Weekly service </h5>
                <p> Click to view</p>
              </div>
            </div>
            <div className="arrow_go">
              <ArrowRightOutlined />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
